import { render } from "./OfficerGroupMembersView.vue?vue&type=template&id=aa2bf9f0&scoped=true"
import script from "./OfficerGroupMembersView.vue?vue&type=script&lang=js"
export * from "./OfficerGroupMembersView.vue?vue&type=script&lang=js"

import "./OfficerGroupMembersView.vue?vue&type=style&index=0&id=aa2bf9f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2bf9f0"]])

export default __exports__